import React, { useContext, useEffect } from "react"

import { useSearchParams } from "react-router-dom"
import { customPalette } from "../../../../../../theme"
import { IconInbox } from "../../../../../components/custom-icons/icon-inbox"
import { TabEnum } from "../../../../../components/tabs/tabs"
import { pagesUrl } from "../../../../../core/appConstants"
import { AppSideBarContext } from "../../../../../core/context/AppSideBarContext/AppSideBarContext"
import { BSVariantContext } from "../../../../../core/context/beem-shot/BSVariant/BSVariantContext"
import { AppNavBarContext, NavbarTypeEnum } from "../../../../../core/context/nav-bar/AppNavBarContext"
import { CoverImgProjectContext } from "../../../../../core/context/project/CoverImgProjectContext"
import { ProjectContext } from "../../../../../core/context/project/ProjectContext"
import { resolveUrl } from "../../../../../core/services/http-service"
import { BSVariantControlPanel } from "./components/BSVariantControlPanel"

export function BSVariantDetailsPage(): React.JSX.Element {
  const [searchParams] = useSearchParams()

  const { setShowAppSide, setFullScreen } = useContext(AppSideBarContext)
  const { setTypeNavBar, setImageFile, setIcon, setTitle, setPreviousUrl } = useContext(AppNavBarContext)
  const { file } = useContext(CoverImgProjectContext)
  const { selectedVariant } = useContext(BSVariantContext)
  const { project } = useContext(ProjectContext)

  useEffect(() => {
    setTypeNavBar(NavbarTypeEnum.BEEM_SHOT_VARIANT)
    setImageFile(file)
    setIcon(<IconInbox sx={{ color: customPalette.black, fontWeight: "2px" }} />)
    setTitle(selectedVariant?.name ?? "")
    setPreviousUrl(resolveUrl(pagesUrl.PROJECT_PAGE_DETAIL, [project?.id], { tab: TabEnum.PROJECT_BEEM_SHOT }))
    setFullScreen(true)

    return () => {
      setFullScreen(false)
    }
  }, [
    file,
    project?.id,
    selectedVariant?.name,
    searchParams,
    setFullScreen,
    setIcon,
    setImageFile,
    setPreviousUrl,
    setTitle,
    setTypeNavBar,
  ])

  useEffect(() => {
    setShowAppSide(false)
  }, [setShowAppSide])

  return <BSVariantControlPanel />
}
